// Id khung giờ đường huyết, trùng với webhook (FastingId / BeforeMealId / AfterMealId)
export const GLUCOSE_TIME_FRAMES = [
  { id: 'b56c18ec-f4d6-4dbf-8b64-8916beeabbbf', label: 'Lúc đói' },
  { id: 'a56c18ec-f4d6-4dbf-8b64-8916beeabbbf', label: 'Trước ăn' },
  { id: 'a59c18ec-f4d6-4dbf-8b64-8916beeabbbf', label: 'Sau ăn' },
];

// Id bữa ăn, trùng với webhook (NutritionTimeFrames). AI không trả bữa thì webhook mặc định bữa trưa
export const MEAL_TIME_FRAMES = [
  { id: 'b770d23f-8444-4a36-9621-58cc24a39906', label: 'Bữa sáng' },
  { id: '9a4c53ca-7c5e-4d3c-9452-07fe19fc2aff', label: 'Bữa trưa' },
  { id: '95faf80c-a6cb-4796-8d65-7478eb875833', label: 'Bữa tối' },
  { id: '6b0684ea-5e03-45ef-a5be-03c9aa4a9c03', label: 'Bữa phụ' },
];

export const DEFAULT_MEAL_TIME_FRAME = '9a4c53ca-7c5e-4d3c-9452-07fe19fc2aff';
